module.exports = __webpack_public_path__ + "static/media/movePrompt.d6ff216b.svg";